// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import firebase from 'firebase'

Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import * as tesla from "./tesla";
Vue.prototype.$tesla = tesla;

// import cors from "cors"
// Vue.use(cors({ origin: true, credentials: true }));

/*
const firebaseConfig = {
  apiKey: "AIzaSyCQi35V9q2CIFz9LdWxyLzmSWuDGCsXXs4",
  authDomain: "teslcar.firebaseapp.com",
  databaseURL: "https://teslcar.firebaseio.com",
  projectId: "teslcar",
  storageBucket: "teslcar.appspot.com",
  messagingSenderId: "31057842289",
  appId: "1:31057842289:web:263fdee311db38fd25cbd0",
  measurementId: "G-W2TSBMPQZD"
};
firebase.initializeApp(firebaseConfig);
Vue.prototype.$firebase = firebase;
*/


window.$ = window.jQuery = require("jquery");

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js